// src/components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading, loginWithGoogle, logout } = useAuth();

  // Wait for Firebase to check the auth state before redirecting
  if (loading) return <div>Loading...</div>;

  if (!user) {
    // If no user is logged in, redirect to login page
	//alert('ProtectedRoute: user not found');
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
